import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

const RESERVED = ["aff", "rot", "rv"];
const inflight = {};

// One resolve per code per page load, so double-mounted effects don't count a visitor twice.
function resolveOnce(code, seen) {
  if (!inflight[code]) {
    inflight[code] = api.get(`/public/rotator/${encodeURIComponent(code)}`, { params: seen ? { seen } : {} });
  }
  return inflight[code];
}

function storageGet(key) {
  try { return window.localStorage.getItem(key); } catch { return null; }
}
function storageSet(key, value) {
  try { window.localStorage.setItem(key, value); } catch { /* private mode */ }
}

// Public /go/:code — picks a landing page for this visitor and forwards them (repeat visitors keep their page).
export default function RotatorRedirect() {
  const { code } = useParams();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const key = `rot_${code}`;
    const seen = storageGet(key);
    resolveOnce(code, seen)
      .then(({ data }) => {
        storageSet(key, data.slug);
        const target = new URL(data.url_path, window.location.origin);
        new URLSearchParams(window.location.search).forEach((v, k) => {
          if (!RESERVED.includes(k)) target.searchParams.set(k, v);
        });
        if (data.aff) target.searchParams.set("aff", data.aff);
        target.searchParams.set("rot", data.code);
        target.searchParams.set("rv", data.slug);
        window.location.replace(`${target.pathname}${target.search}`);
      })
      .catch(() => setFailed(true));
  }, [code]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6 text-center" data-testid="rotator-redirect">
      {failed
        ? <p className="text-sm text-zinc-700" data-testid="rotator-redirect-error">This link isn&apos;t active right now.</p>
        : <p className="text-sm text-zinc-500" data-testid="rotator-redirect-loading">Loading…</p>}
    </div>
  );
}
